import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

import { RcsLogin } from '../../assets/shared/rcs-login.class';
import { RcsAppConfig } from '../../assets/app.config';
import { RcsConnectorIndexDbProvider } from '../rcs-connector-index-db/rcs-connector-index-db';
import { ENV } from '@app/env';

@Injectable()
export class RcsConnectorOdooProvider{

  private odoo_path:string
  private odoo_db:string

  constructor(
    public http: Http,
    private rcs_app_config: RcsAppConfig,
    private kd_database_service: RcsConnectorIndexDbProvider) {}

  public get(login:RcsLogin, prototyp:any, item, filter:Array<any>, limit:number, offset:number, context:any = {}){
    let fields = prototyp.get_attributs();
    return Observable.create(observer => {
    this.search_read(login, item, filter, fields, limit, context).subscribe(
      (main_modules) => {
        if (main_modules.json().result.length > 0){
          for (let main_modul of main_modules.json().result){
            let sub_moduls = this.get_sub_modules(prototyp, login, main_modul);
            observer.next(Observable.forkJoin(sub_moduls).map(
              sub_moduls => {
                for (let sub_modul of sub_moduls){
                  main_modul[sub_modul['name']] = sub_modul['value'];
                }
                return main_modul;
              }
            ));
          }
        }else{
          observer.next();
        }
      },
      error => { 
        console.log(error);
        observer.next(false);
        observer.complete();
      },
    () => { observer.complete(); }
    )
    })
  }

  public get_sub_modules(prototyp, login, main_modul){
    let sub_moduls = prototyp.get_sub_object_definition();
    let modul_list = [];
    for (let sub_modul of sub_moduls){
      let sub_modul_name = sub_modul.name;
      let ids = main_modul[sub_modul.main_field];
      if (sub_modul.main_field === 'partner_id'){
        ids = main_modul[sub_modul.main_field][0];
      }
      modul_list.push(this.read_records(login, sub_modul.model, ids, sub_modul.fields, 0).map(
        (response) => {
          let sub_modul = [];
          if (typeof(response.json().result) !== 'undefined'){
            sub_modul = response.json().result;
          }
          return {'name': sub_modul_name, 'value': sub_modul};
        })
    )}
    return modul_list;
  }

  // Loginfunktion für das Odoosystem
  public login(name:string, passwort:string):Observable<any>{
    this.load_connection_data();
    let params = {
      "service" : 'common',
      "method" : 'login',
      "args" : [this.odoo_db, name, passwort]
    }
    return this.send_jsonrcp_request(params);
  }

  // About-Funktion für das Odoosystem (als Pingtest)
  public about():Observable<any>{
    this.load_connection_data();
    console.log(this);
    let params = {
      "service" : 'common',
      "method" : 'about',
      "args" : []
    }
    return this.send_jsonrcp_request(params);
  }

  // Ruft selbstdefinierte Methoden von Models auf
  public call(rcs_login:RcsLogin, model:string, method:string, args:any, id:any = null, context:any = {}):Observable<any>{
    let params = {
      "service" : 'object',
      "method" : 'execute',
      "args" : [
        this.odoo_db, rcs_login.uid, rcs_login.passwort,
        model, method, args, context
      ]
    }
    return this.send_jsonrcp_request(params, id);
  }

  // Listet die IDs von gesuchten Records auf
  public list_records(rcs_login:RcsLogin, item:string, filter: any = [], context:any = {}):Observable<any>{
    let params = {
      "service" : 'object',
      "method" : 'execute',
      "args" : [
        this.odoo_db, rcs_login.uid, rcs_login.passwort,
        item, 'search', filter, context
      ]
    }
    return this.send_jsonrcp_request(params);
  }

  // Zählt alle gesuchten Records
  public count_records(rcs_login:RcsLogin, item:string, filter: any = [], context:any = {}):Observable<any>{
    let params = {
      "service" : 'object',
      "method" : 'execute',
      "args" : [
        this.odoo_db, rcs_login.uid, rcs_login.passwort,
        item, 'search_count', filter, context
      ]
    }
    return this.send_jsonrcp_request(params);
  }

  // Gibt Feldtypen von Records zurück
  public read_records(rcs_login:RcsLogin, item:string, ids:any, fields:any = [], context:any = {}):Observable<any>{
    let params = {
      "service" : 'object',
      "method" : 'execute',
      "args" : [
        this.odoo_db, rcs_login.uid, rcs_login.passwort,
        item, 'read', ids, fields, context
      ]
    }
    return this.send_jsonrcp_request(params);
  }
  // Gibt Records mit Ihren Feldern und Typen zurück
  public listing_record_fields(rcs_login:RcsLogin, item:string, attribute:any = [], context:any = {}):Observable<any>{
    let params = {
      "service" : 'object',
      "method" : 'execute',
      "args" : [
        this.odoo_db, rcs_login.uid, rcs_login.passwort,
        item, 'fields_get', [],
        {'attributes': attribute},
        context
      ]
    }
    return this.send_jsonrcp_request(params);
  }

  // Product Funktion
  public get_products(rcs_login:RcsLogin, model:string, args:any = [], fields:any = [], offset:number = 0, limit:number = 0, context:any = {}){
    let params = {
      "service" : 'object',
      "method" : 'execute',
      "args" : [
        this.odoo_db, parseInt(rcs_login.uid), rcs_login.passwort,
        model, 'search_read', args, fields,
        offset, limit,
        "write_date asc", context
      ]
    }
    return this.send_jsonrcp_request(params);
  }

  // Gibt Records zurück
  public search_read(rcs_login:RcsLogin, item:string, filter:any = [], feldnamen:any = [], limit:any = 0, context:any = {}){
    let params = {
      "service" : 'object',
      "method" : 'execute',
      "args" : [
        this.odoo_db, parseInt(rcs_login.uid), rcs_login.passwort,
        item, 'search_read', filter,
        feldnamen,
        0,
        parseInt(limit),
        "name asc",
        context
      ]
    }
    return this.send_jsonrcp_request(params);
  }

  // Gibt Records zurück (ohne Sortierung)
  public simple_search_read(rcs_login:RcsLogin, item:string, filter:any = [], feldnamen:any = [],context:any = {}){
    let params = {
      "service" : 'object',
      "method" : 'execute',
      "args" : [
        this.odoo_db, parseInt(rcs_login.uid), rcs_login.passwort,
        item, 'search_read', filter,
        feldnamen,
        context
      ]
    }
    return this.send_jsonrcp_request(params);
  }

  // Erstellt Records
  public create_record(rcs_login:RcsLogin, item:string, records:any, context:any = {}):Observable<any>{
    let params = {
      "service" : 'object',
      "method" : 'execute',
      "args" : [
        this.odoo_db, rcs_login.uid, rcs_login.passwort,
        item, 'create', records, context
      ]
    }
    return this.send_jsonrcp_request(params);
  }

  // Updatet Records
  public update_record(rcs_login:RcsLogin, item:string, id:any, records:any, context:any = {}):Observable<any>{
    let params = {
      "service" : 'object',
      "method" : 'execute',
      "args" : [
        this.odoo_db, rcs_login.uid, rcs_login.passwort,
        item, 'write', id, records, context
      ]
    }
    return this.send_jsonrcp_request(params, id);
  }

  // Entfernt Records
  public delete_record(rcs_login:RcsLogin, item:string, id:any, context:any = {}):Observable<any>{
    let params = {
      "service" : 'object',
      "method" : 'execute',
      "args" : [
        this.odoo_db, rcs_login.uid, rcs_login.passwort,
        item, 'unlink', id, context
      ]
    }
    return this.send_jsonrcp_request(params);
  }

  // Sendet Workflow Signale an das Odoo
  public workflow_manipulations(rcs_login:RcsLogin, item:string, method:string, invoice_id:number, context:any = {}):Observable<any>{
    let params = {
      "service" : 'object',
      "method" : 'exec_workflow',
      "args" : [
        this.odoo_db, rcs_login.uid, rcs_login.passwort,
        item, method, invoice_id, context
      ]
    }
    return this.send_jsonrcp_request(params, invoice_id);
  }

  // Lädt die Verbindungsdaten aus der Datenbank
  public load_connection_data(){
    this.kd_database_service.database.createStore(1, evt => {
      evt.currentTarget.result.createObjectStore('system', { keyPath: "id", autoIncrement: false });
    }).then(success => {
      this.kd_database_service.get_record_by_key('system', 'system_options').subscribe(
        success => {
          if (typeof(success) !== 'undefined'){
            this.odoo_db = success.odoo_db;
            this.odoo_path = success.odoo_path;
          }else{
            this.odoo_db = ENV.odoo_db; //this.rcs_app_config.odoo_db;
            this.odoo_path = ENV.odoo_path; //this.rcs_app_config.odoo_path;
          }
        }
      )
    });
  }

  // Sendet einen JSON-Request an den Server und gibt ein Observable zurück
  private send_jsonrcp_request(params:any, id:number = null):Observable<any>{
    let jsondata = {
      "jsonrpc": "2.0",
      "method": "call",
      "id": id,
      "params": params
    };

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    //return new Observable<any>( (subscr: Subscriber<any>) => {
    return this.http.post(this.odoo_path + '/jsonrpc', jsondata, {"headers": headers})
          /*.subscribe( (res) => {
            //console.log(res.json().result);
            subscr.next(res);
          },
          error => {
            console.log(error);
            subscr.error(error);
          });
    });*/
  }
}



// WEBPACK FOOTER //
// ./src/providers/rcs-connector-odoo/rcs-connector-odoo.ts